<template>
  <div class="modal-card editVideoModal has-background-white">
    <div class="parentGrid">
      <!-- add videos -->
      <div>
        <addToPlaylist @selectVideo="selectVideo" @addVideo="addVideo" />
      </div>
      <!-- edit title, notes, and video order -->
      <div class="scroll-wrapper">
        <div class="scroll-header is-flex">
          <div class="width-100 pr-2 is-flex is-align-items-center is-justify-content-flex-end">
            <b-button class="mb-0 mr-1" @click="$parent.close()">
              <strong>Cancel</strong>
            </b-button>
            <b-button class="mb-0 is-success" @click="saveChanges()" :disabled="!localPlaylist.name || localPlaylist.videos.length < 1">
              <strong>Save</strong>
            </b-button>
          </div>
        </div>
        <div class="scroll-content py-2 mr-2">
          <div class="infoContainer has-text-left pb-4">
            <b-field label="Name (required)" label-position="on-border" required>
              <b-input v-model="localPlaylist.name" placeholder="Playlist name" />
            </b-field>
            <b-tooltip :active="!localPlaylist.notes || localPlaylist.notes.length < 4" label="Your patient will see these notes." type="is-dark" position="is-top" class="width-100">
              <div class="field is-floating-label">
                <label class="label">Notes</label>
                <textarea v-model="localPlaylist.notes" class="textarea mb-1 border-8" :placeholder="`${playlist.data.name} notes...`" />
              </div>
            </b-tooltip>
          </div>
          <!-- list of videos in a playlist -->
          <div class="px-1">
            <draggable class="list-group" tag="ul"
              @start="drag = true" @end="drag = false"
              handle=".handle"
              v-model="localPlaylist.videos"
              v-bind="dragOptions"
            >
              <transition-group type="transition" :name="!drag ? 'flip-list' : null" tag="ul">
                <li class="list-group-item videoContainer border-8 mb-3"
                  v-for="(video, idx) in localPlaylist.videos"
                  :key="video.randKey"
                >
                  <div class="has-text-left columns">
                    <div class="column is-flex is-align-items-center is-justify-content-center pl-4 pr-0 py-0">
                      <div class="is-flex  is-align-content-center">
                        <b-icon icon="drag-variant" class="handle" />
                        <!-- <b-button @click="deleteVideo(idx)" class="is-danger is-light">
                          <b-icon icon="delete" />
                        </b-button> -->
                      </div>
                    </div>
                    <div class="column">
                        
                        <div class="clippingBG is-relative">
                          <img :src="video.screenshots[1].link" class="clipImage" />
                          <div @click="selectVideo(video)" class="is-overlay is-clickable">
                            <div class="iconContainer">
                              <b-icon icon="play-circle-outline" type="is-white" size="is-large" />
                            </div>
                            <div class="is-overlay timeContainer">
                              <p class="has-text-white">{{ $root.convertTime(video.duration) }}</p>
                            </div>
                          </div>

                          <div class="is-absolute is-pulled-right deleteVideo">
                            <b-button @click="deleteVideo(idx)" class="is-light" outline>
                              <b-icon icon="delete" type="is-danger" />
                            </b-button>
                          </div>

                        </div>
                        <div class="ml-2">
                          <strong>{{ video.name }}</strong>
                        </div>

                    </div>
                  </div>
                </li>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="playVideo">
      <videoPlayer v-if="playVideo" :video="vimeoID" />
    </b-modal>

  </div>
</template>



<script>
import draggable from "vuedraggable";

import videoPlayer from "@/components/builder/videoPlayer";
import addToPlaylist from "@/components/builder/addToPlaylist";

export default {
  name: "editPlaylist",
  components: {
    draggable,
    videoPlayer,
    addToPlaylist
  },
  props: {
    playlist: Object,
    week: Number
  },
  data() {
    return {
      playVideo: false,
      vimeoID: null,
      drag: false, // for vuedraggable
      localPlaylist: {
        completion: 0,
        date: null,
        duration: 0,
        key: '',
        name: 'Playlist',
        notes: '',
        videos: []
      }
    };
  },
  mounted() {
    this.localPlaylist = JSON.parse(JSON.stringify(this.playlist.data)); // stringify and recreate the object so we pass by value
  },
  computed: {
    dragOptions() { // options for vuedraggable
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    playlistDuration() {
      let total = 0;
      this.localPlaylist.videos.map(video => {
        if (video.type !== 'intro' && video.type !== 'outro') {
          total += video.duration
        }
      });
      return total;
    }
  },
  methods: {
    selectVideo(video) {
      this.vimeoID = video.vimeoID;
      this.playVideo = true;
    },
    deleteVideo(video) {
      this.localPlaylist.videos.splice(video, 1);
    },
    addVideo(video) {
      let videoKeyed = JSON.parse(JSON.stringify(video)); // force passing by value to avoid duplicate videos/keys
      videoKeyed.randKey = Date.now();
      this.localPlaylist.videos.push(videoKeyed);
    },
    saveChanges() {
      this.localPlaylist.duration = this.playlistDuration; // manually set before saving to avoid re structuring localPlaylist
      this.$store.commit('UPDATE_PLAYLIST', {
        week: this.week,
        playlist: {
          idx: this.playlist.idx,
          data: this.localPlaylist,
        }
      });
      this.$parent.close();
      this.$buefy.toast.open(`Saved`)
    }
  }
};
</script>



<style lang="scss" scoped>

.is-absolute {
  position: relative; 
  margin-left: 80%;
  margin-top: -8.5vh;
  .button {
    background-color: rgba(#ffcccc, 0.8)!important;
  }
}


.parentGrid {
  display: grid;
  grid-template-columns: 1fr minmax(200px, 35%);
}

.editVideoModal {
  border-radius: 8px;
}

.videoContainer {
  border: solid 1px hsl(0, 0%, 86%);
  background-color: white;
  // background-color: hsl(0, 0%, 96%);
}

.handle {
  cursor: move;
}

.border-8 {
  border-radius: 8px!important;
}

.clipImage {
  position: absolute;
  clip-path: inset(20px 0 20px round 0 8px 0 0)!important;
  border-radius: 12px !important;
}
</style>